import React from 'react';
import { useSelector } from 'react-redux';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ApplicationState } from 'store';
import 'translations/translations';
import { getAuthorizedDepartments } from 'helpers/authorizedDepartments';

interface ParamTypes {
  orgId: string;
  deptId: string;
  stackId: string;
}

const DepartmentSelect = () => {
  const history = useHistory();
  const { t } = useTranslation(['translations']);
  const { orgId, deptId, stackId } = useParams<ParamTypes>();

  const userAccess = useSelector(
    (state: ApplicationState) => state.isLoggedIn?.userAccess,
  );

  const orgDepartments = useSelector(
    (state: ApplicationState) => state.organization?.organization?.departments,
  );
  const accessibleDepartments = useSelector(
    (state: ApplicationState) => state.isLoggedIn?.userAccess?.departments,
  );

  const departments = getAuthorizedDepartments(
    orgId,
    userAccess,
    orgDepartments,
    accessibleDepartments,
  );

  const urlSplit = location.pathname.split('/');
  const targetComponent = urlSplit[urlSplit.length - 1];

  const handleSelect = (value: string) => {
    if (stackId) {
      history.push(`/organization/${orgId}/department/${value}/stacks`);
    } else if (targetComponent !== deptId && targetComponent !== orgId) {
      history.push(
        `/organization/${orgId}/department/${value}/${targetComponent}`,
      );
    } else {
      history.push(`/organization/${orgId}/department/${value}`);
    }
  };

  return (
    <FormControl variant="outlined" fullWidth={true}>
      <Select
        value={deptId || 'all'}
        onChange={(
          e: React.ChangeEvent<{
            name?: string | undefined;
            value: unknown;
          }>,
        ) => handleSelect(e.target.value as string)}
      >
        {<MenuItem value="all">{t('stacks_page.all_departments')}</MenuItem>}
        {departments?.map((department) => (
          <MenuItem
            value={department.departmentId}
            key={department.departmentId}
          >
            {department.name ? department.name : ''}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { DepartmentSelect };
